import { Component } from '@angular/core';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-partner-portal',
    templateUrl: './partner-portal.component.html',
    styleUrls: ['./partner-portal.component.scss'],
    imports: [RouterLink, RouterLinkActive, MatIcon, RouterOutlet]
})
export class PartnerPortalComponent {
  constructor() {}
}
